import fetchHandler from "../../utils/fetchHandler";
import { BADGES } from "../types/actions";

export const getBadges = () => {
    const fetchOptions = {
        url: `/api/badges/`,
        method: "GET",
        actionType: BADGES.GET_BADGES
    };
    return fetchHandler(fetchOptions);
};

export const getBadgeDetails = (id) => {
    const fetchOptions = {
        url: `/api/member_badge/?badge=${id}`,
        method: "GET",
        actionType: BADGES.GET_BADGE_DETAILS
    };
    return fetchHandler(fetchOptions);
};